module.exports = __webpack_public_path__ + "static/media/top2.bf94acda.jpg";